/* eslint-disable default-param-last */
export const trialInfoReducer = (state = null, action) => {
  switch (action.type) {
    case 'SET_TRIAL_STATUS':
      return action.trialStatus;
    default:
      return state;
  }
};
